import React, { FC, ReactElement } from 'react'
import styles from './WalletBalanceDisplay.module.css'
import Satoshis from '@/components/satoshis'
import classNames from 'classnames'

const WalletBalanceDisplay: FC<{
	confirmedSatoshis: number;
	unconfirmedSatoshis: number;
	isLoading?: boolean;
}> = (
	props
): ReactElement => {
	const { confirmedSatoshis, unconfirmedSatoshis, isLoading } = props

	return (
		<div className={styles.root}>
			<Satoshis
				className={classNames('display-md', 'semibold')}
				satoshis={confirmedSatoshis}
				iconClassName={styles.btcIcon}
				skeleClassName={styles.skele}
				isLoading={isLoading}
			/>
			{!!unconfirmedSatoshis && (
				<div className={styles.incomingBalanceContainer}>
					<Satoshis
						className={classNames('text-md', 'regular')}
						satoshis={unconfirmedSatoshis}
						iconClassName={styles.btcIconSmall}
					/>
					<span className={classNames(styles.incomingLabel, 'text-md', 'regular')}>Incoming</span>
				</div>
			)}
		</div>
	)
}

export default WalletBalanceDisplay
